import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || '/api';

// API authentifiée (hôtesse / responsable). Le jeu public utilise playApi ci-dessous.
const api = axios.create({ baseURL: API_URL, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('palet_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.startsWith('/auth/login')) {
      localStorage.removeItem('palet_token');
      localStorage.removeItem('palet_user');
      window.location.assign('/login');
    }
    return Promise.reject(error);
  },
);

/** Message lisible depuis une erreur API ({detail: {code, message}} ou {detail: "..."}). */
export function errorMessage(error, fallback = 'Une erreur est survenue.') {
  const d = error?.response?.data?.detail;
  if (!error?.response) return 'Connexion impossible. Vérifiez le réseau puis réessayez.';
  if (typeof d === 'string') return d;
  if (d?.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(' ; ');
  return fallback;
}

export function errorCode(error) {
  return error?.response?.data?.detail?.code || null;
}

// ---- Jeu public : pas de jeton, pas de redirection, délais courts et relances.
async function request(method, path, body, timeoutMs = 8000) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch(`${API_URL}${path}`, {
      method,
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
      signal: ctrl.signal,
      cache: 'no-store',
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data?.detail?.message || 'Erreur');
      err.status = res.status;
      err.code = data?.detail?.code;
      throw err;
    }
    return data;
  } catch (e) {
    if (e.status) throw e;
    const err = new Error('network');
    err.network = true;
    throw err;
  } finally {
    clearTimeout(timer);
  }
}

export const playApi = {
  state: (token) => request('GET', `/palet/play/${encodeURIComponent(token)}`),
  choose: (token, box, input) =>
    request('POST', `/palet/play/${encodeURIComponent(token)}/choose`, { box, input }),
};

export default api;
